import { API_ROOT, TIMEOUT } from '../../config/config'
import { axiosInterceptors } from '../utils/httpClient'
import { doDownload, doGet, doPost, doPut } from './utils'

export const getProposeConsiderApproveProject = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approve/proposal`
  return doGet(url)
}

export const getProposeConsiderApproveProjectFileList = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approve/proposal/attactment`
  return doGet(url)
}

export const saveProposeConsiderApproveProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/proposal`
  return doPost(url, request)
}

export const updateProposeConsiderApproveProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/proposal`
  return doPut(url, request)
}

export const saveDraftProposeConsiderApproveProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/proposal/draft`
  return doPost(url, request)
}

export const updateDraftProposeConsiderApproveProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/proposal/draft`
  return doPut(url, request)
}

export const seveSummaryNote = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approval/summary-note`
  return doPost(url, request)
}

export const uploadDocuments = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approval/file/upload`
  return doPost(url, request)
}

export const deleteDocument = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approval/file/delete`
  return axiosInterceptors
    .delete(url, { timeout: TIMEOUT, data: request })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const renameDocument = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approval/file/rename`
  return doPut(url, request)
}

export const downloadDocument = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approval/file/${fileId}/download`
  return doDownload(url)
}

export const downloadRequestApproveFile = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/requestapprove/form`
  return doDownload(url)
}

export const getContractCenterReviewBeforeApprove = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/contractcenter/review/before-approve`
  return doGet(url)
}

export const saveContractCenterReviewBeforeApprove = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/contractcenter/review/before-approve`
  return doPost(url, request)
}

export const updateReadyForReviewBeforeApprove = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review-summary/ready`
  return doPut(url, request)
}

export const rejectApproval = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/reject/proposal`
  return doPut(url, request)
}

export const getApproverList = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/approver/verify`
  return doGet(url)
}

// ---------------------------------- subproject
export const uploadDocumentsSubProject = (projectVersionId, request) => {
  // /api/subproject/{projectVersionId}/approval-attachments
  const url = `${API_ROOT}/subproject/${projectVersionId}/approval-attachments`
  return doPost(url, request)
}

export const deleteDocumentSubProject = (projectVersionId, request) => {
  // /api/subproject/{projectVersionId}/approval-attachments/{fileId}
  const url = `${API_ROOT}/subproject/${projectVersionId}/approval-attachments/${request.id}`
  return axiosInterceptors
    .delete(url, { timeout: TIMEOUT, data: request })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const renameDocumentSubProject = (projectVersionId, request) => {
  // /api/subproject/{projectVersionId}/approval-attachments/{fileId}
  const url = `${API_ROOT}/subproject/${projectVersionId}/approval-attachments/${request.id}`
  return doPut(url, request)
}

export const downloadDocumentSubProject = (projectVersionId, path) => {
  // http://103.91.191.229:9000/api/subproject/{projectVersionId}/approval-attachments/download?path=xxx
  const url = `${API_ROOT}/subproject/${projectVersionId}/approval-attachments/download?path=${path}`
  return doDownload(url)
}

export const getApprovalAttachmentsSubProject = (projectVersionId) => {
  // http://103.91.191.229:9000/api/subproject/{projectVersionId}/approval-attachments
  const url = `${API_ROOT}/subproject/${projectVersionId}/approval-attachments`
  return doGet(url)
}
// ----------------------------------
